import { QueryKey } from '@tanstack/query-core';
import { ENDPOINT_CONFIG } from 'config/Request/endpoints';

import { determineContentType } from 'utility/Request/rpc';

import { ApiEndpoint, EndpointTypeMap } from 'types/Request/endpoint';

import { callApiEndpoint, getApiEndpointConfig } from './Api';
import { ApiCallOptions } from './Api/types';

const defaultRpcContentType = determineContentType();

/**
 * wrapper for getApiEndpointConfig, bound to desktop endpoints
 */
export const getEndpointConfig = <
    Endpoint extends ApiEndpoint,
    TError = unknown,
    TQueryKey extends QueryKey = QueryKey
>(
    endpoint: Endpoint
) =>
    getApiEndpointConfig<EndpointTypeMap, Endpoint, TError, TQueryKey>(
        ENDPOINT_CONFIG,
        endpoint
    );

/**
 * wrapper for callApiEndpoint, bound to desktop endpoints
 */
export const callApi = async <Endpoint extends ApiEndpoint>(
    endpoint: Endpoint,
    options?: ApiCallOptions<EndpointTypeMap, Endpoint>
) =>
    callApiEndpoint(
        ENDPOINT_CONFIG,
        defaultRpcContentType,
        endpoint,
        options ?? {}
    );
